"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var menu_icon_svg_1 = __importDefault(require("@assets/widgets/app/menu-icon.svg"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        locationImg: {
            height: 25,
            userDrag: 'none',
        },
    });
});
var MenuWidget = function () {
    var classes = useStyles();
    return (react_1.default.createElement("img", { src: menu_icon_svg_1.default, className: classes.locationImg, alt: "location-icon" }));
};
exports.default = MenuWidget;
